import { htmlDecode }  from '@mdigital/common/dist/utils/html';

export function setThankYouPromptImage(isDarkModeImage, sameDarkModeImageAsLight, setLightImage, setDarkImage, image) {
  if(isDarkModeImage) {
    setDarkImage(image);
  }else if(!isDarkModeImage && sameDarkModeImageAsLight){
    setDarkImage(image);
    setLightImage(image);
  }else {
    setLightImage(image);
  }
}

export const parseHyperLinkValue = (value = '') =>
  htmlDecode(value)
    .replace(/&lta/gi, '<a')
    .replace(/&lt\/a/gi, '</a>')
    .replace(/href/g, "target='_blank' href")
    .replace(/&ltbr\s*\/?&gt/gi, '<br>');